<template>
  <!--头部导航栏-->
  <a-menu mode="horizontal" class="header-bar">
    <a-menu-item style="line-height:10vh;width: 20vw;padding: 0">
      <router-link @click.passive="backtotop" :to="'/index_m'">
        <img src="../../assets/logo.svg" style="width: 145px;height: 40px">
      </router-link>
    </a-menu-item>
    <a-menu-item style="width: 40vw">
    </a-menu-item>
    <a-menu-item style="width: 10vw;padding: 0;margin-bottom: 1.6vh">
      <router-link :to="'/search_m'">
        <SearchOutlined :style="{fontSize: '22px', margin: '0'}"/>
      </router-link>
    </a-menu-item>
    <a-menu-item style="line-height:10vh;width: 10vw;padding: 0">
      <img src="../../assets/en.png" style="height: 8vw;width: 8vw" @click.passive="to">
    </a-menu-item>
    <a-menu-item style="line-height:10vh;width: 10vw;padding: 0">
      <a-dropdown :trigger="['click']">
        <MenuOutlined v-if="menu.icon" @click="open_menu"/>
        <CloseOutlined v-else @click="close_menu"/>
        <template #overlay>
          <a-menu style="top: 3vh; width: 100vw;">
            <a-menu-item v-for="(item, index) in routers" :key="index">
              <router-link :to="item.url" @click.passive="backtotop">{{ item.title }}</router-link>
            </a-menu-item>
          </a-menu>
        </template>
      </a-dropdown>
    </a-menu-item>
  </a-menu>
</template>

<script>
import {reactive} from 'vue'
import {SearchOutlined, MenuOutlined, CloseOutlined} from '@ant-design/icons-vue'

export default {
  name: 'Header_m',
  components: {
    SearchOutlined,
    MenuOutlined,
    CloseOutlined,
  },
  setup() {
    const menu = reactive({
      icon: true,
      page: false,
    })
    const routers = reactive([  //路由对应
      {url: '/index_m', title: '首页'},
      {url: '/concept_m', title: '投资理念'},
      {url: '/team_m', title: '投资团队'},
      {url: '/enterprise_m', title: '被投企业'},
      {url: '/news_m', title: '公司新闻'},
      {url: '/contact_m', title: '联系我们'},
    ])
    const backtotop = () => {  //回到头部位置
      document.documentElement.scrollTo(0, 0)
    }
    const to = () => {
      let thisPage = window.location.href.toString();
      if (thisPage.search('/index') !== -1) {
        thisPage = thisPage.replace('index', 'index_en')
      } else if (thisPage.search('/concept') !== -1) {
        thisPage = thisPage.toString().replace('concept', 'concept_en')
      } else if (thisPage.search('/team') !== -1) {
        thisPage = thisPage.toString().replace('team', 'team_en')
      } else if (thisPage.search('/enterprise') !== -1) {
        thisPage = thisPage.toString().replace('enterprise', 'enterprise_en')
      } else if (thisPage.search('/news') !== -1) {
        thisPage = thisPage.toString().replace('news', 'news_en')
      } else if (thisPage.search('/contact') !== -1) {
        thisPage = thisPage.toString().replace('contact', 'contact_en')
      } else if (thisPage.search('/search') !== -1) {
        thisPage = thisPage.toString().replace('search', 'search_en')
      }
      window.location.href = thisPage
    }
    const open_menu = () => {
      menu.icon = false
      menu.page = true
    }
    const close_menu = () => {
      menu.icon = true
      menu.page = false
    }
    return {backtotop, routers, menu, open_menu, close_menu, to}
  }
}
</script>

<style scoped>
.header-bar {
  font-weight: bold;
  height: 10vh;
  list-style-type: none;
  margin: 0;
  padding: 0;
  overflow: hidden;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 999;
}

.ant-dropdown-menu-item {
  line-height: 5vh;
}

.item {
  line-height: 22px;
}

</style>
